import {useDraggable} from "@dnd-kit/core";
import {memo, useEffect} from "react";
import { CSS } from "@dnd-kit/utilities";
import {DragItemType} from "../../types";
import {renderItems} from "../../ToolsPanel/items";
import {useSizeItem} from "../../provider/ResizeProvider";
import styled, {css, keyframes} from "styled-components";

interface Props {
    dragItem: DragItemType;
    id?: string;
}

const dropShadowAnimation = keyframes`
    0% {
        filter: drop-shadow(0px 0px 8px gold);
    }
    50% {
        filter: drop-shadow(0px 0px 2px gold);
    }
    100% {
        filter: drop-shadow(0px 0px 8px gold);
    }
`;

const DraggableContainer = styled.div<{ isDragging: boolean }>`
    animation: ${({ isDragging }) =>
        !isDragging ? css`${dropShadowAnimation} 2s infinite` : 'none'};
`;

const Draggable = memo(({dragItem, id = 'drag'}: Props) => {
    const {itemSize, panelItemSize} = useSizeItem();
    const { attributes, isDragging, listeners, setNodeRef, transform } =
        useDraggable({ id });

    useEffect(() => {
        document.body.style.cursor = isDragging ? "grabbing" : "auto";
    }, [isDragging]);

    const style = transform
        ? {
            transform: CSS.Translate.toString(transform),
        }
        : {
            display: 'flex',
            justifyContent: 'center',
            cursor: 'grab',
            width: 60,
            height: 60,
        };

    return (
        <DraggableContainer isDragging={isDragging}>
            <div
                ref={setNodeRef}
                style={{
                    ...style,
                    transition: !isDragging ? "all 140ms ease" : "none",
                }}
                {...listeners}
                {...attributes}
            >
                {renderItems(dragItem.typeOfItem, isDragging, panelItemSize, itemSize)}
            </div>
        </DraggableContainer>
    );
})

export default Draggable;
